import { ConfigurationProtocolAssayResponse } from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol-assay/configuration-protocol-assay.dto'
import { store } from '@/store/store'

export interface ConfigurationLocalAssaysProtocolsModalAssaysFormState {
    protocolAssays: ConfigurationProtocolAssayResponse[],
    laboratoryId: number
}
export const initialConfigurationLocalAssaysProtocolsModalAssaysFormState =
    (): ConfigurationLocalAssaysProtocolsModalAssaysFormState => ({
        protocolAssays: [],
        laboratoryId: store.getters.labId
    })
